module.exports = __webpack_public_path__ + "img/edit-pen.c789bee3.svg";